import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit, getProject, MSG_AUTO_CLOSE_TIME} from '../../shared/util';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './shortCutPane/container';
import {
  clearFormData,
  filterContractListPaneData,
  readByConstructorId,
  readByContractId,
  readContractDropDownData,
  readContractShortCutPaneData,
  saveContractStateAttr,
} from '../../reducers/contractReducer';
import {
  Contract,
  CONTRACT,
  ContractListItem,
  ContractListPaneFilter,
  ContractShortCutPaneItem,
  formData,
} from '../../types/contract';
import {BookMarkItem} from '../../types/template';
import {getContractingUnits} from '../../reducers/cuProjectReducer';
import i18n from '../../../i18n';
import CustomAlert from '../../shared/alert/customAlert';
import {resizerStyle} from '../../shared/customStyle/commonStyles';

export interface State {
  selectedShortCutItem: ContractShortCutPaneItem;
  filter: ContractListPaneFilter;
  formData: Contract;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string;
  constructorFormData: Contract;
  showMsg: boolean,
  alertMsgType: string,
  alertMsg: string,
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: ContractShortCutPaneItem[];
  formData: Contract;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: (collapseBookmarkPane?: boolean) => void;
  reSizer: number;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  readContractShortCutPaneData: () => void;
  filterContractListPaneData: (filter: ContractListPaneFilter) => void;
  readContractDropDownData: () => void;
  readByContractId: (id: string) => void;
  readByConstructorId: (id: string) => void;
  clearFormData: () => void;
  shortcutPaneData: ContractShortCutPaneItem[];
  selectedLotType: any;
  saveContractStateAttr: any;
  contractList: ContractListItem[];
  isContractListLoaded: boolean;
  contractDropDowns: any;
  reloadListPane: boolean;
  collapseBookmarkPane: boolean;
  constructorFormData: Contract;
  getContractingUnits: any;
  isInviteSend: boolean;
}

class ContractMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      filter: new ContractListPaneFilter(),
      selectedShortCutItem: {
        key: null,
        id: null,
        name: null,
        type: null,
        value: null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',  //column-filter-activated
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: formData,
      constructorFormData: formData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
      showMsg: false,
      alertMsgType: '',
      alertMsg: '',
    };
  }

  componentDidMount() {
    this.handleUrlChange();
    this.props.readContractDropDownData();
    // this.props.readContractShortCutPaneData();  uncomment this for shortcut pane
    this.props.filterContractListPaneData(new ContractListPaneFilter());
    this.props.getContractingUnits();

    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    if (this.props.selectedLotType === CONTRACT) {
      this.setState(
        {
          formData: this.props.formData,
        },
        this.props.handleShowDocumentPane,
      );
    } else {
      this.setState(
        {
          constructorFormData: this.props.constructorFormData,
        },
        this.props.handleShowDocumentPane,
      );
    }
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewCONTRACT) {
          this.createNew();
        }

        // if (data.data.collapseDocumentPane) {
        //   this.setState({
        //     reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
        //     isDrag: !this.state.isDrag,
        //     collapseBookmarkPane: !this.state.collapseBookmarkPane,
        //     resetLayout: !this.state.resetLayout,
        //   });
        // }

        if (
          data &&
          data.data &&
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: true });
        } else if (
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          !data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: false });
        }

        if (data.data.refresh) {
          this.refreshDocumentPane();
        }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.reloadListPane !== prevProps.reloadListPane && this.props.reloadListPane) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      // potential [BUG]
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.state.filter != this.props.location.state.contractFilter
    ) {
      if (this.props.location.state.contractFilter) {
        this.setState(
          {
            filter: this.props.location.state.contractFilter,
          },
          this.reloadListPaneItem,
        );
      }
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
    if (this.props.isInviteSend !== prevProps.isInviteSend) {
      if (this.props.isInviteSend) {
        this.setState({
          alertMsgType: 'success',
          alertMsg: this.props.t('invitationSentToContractor'),
          showMsg: true,
        });
        setTimeout(() => {
          this.setState({
            showMsg: false,
          });
        }, MSG_AUTO_CLOSE_TIME);

        this.refreshDocumentPane();
        this.reloadListPaneItem();

      }
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let id = this.props.match.params.featureId ? this.props.match.params.featureId : null;

    if (id && id !== 'new') {
      this.setState(
        {
          isEdit: !!this.props.match.params.featureId,
          isDisableNewButton: id ? true : false,
        }, () => {
          this.props.handleShowDocumentPane(collapseBookmarkPane);
        });
      this.props.selectedLotType === CONTRACT ? this.props.readByContractId(id) : this.props.readByConstructorId(id);
    } else {
      this.setState(
        {
          isEdit: false,
          isDisableNewButton: false,
        }, () => {
          this.props.handleShowDocumentPane();
        });
    }
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  refreshDocumentPane = () => {
    if (this.props.isEdit) {
      let id = this.props.selectedLotType === CONTRACT ? this.props.formData.sequenceId : this.props.constructorFormData.sequenceId;
      this.props.selectedLotType === CONTRACT ? this.props.readByContractId(id) : this.props.readByConstructorId(id);
    }
  };
  // 2. clear states in this method and save to state
  // 3. update redirect url
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = {
      title: null,
      // ....
    };
    this.setState({
      formData: formData,
    });

    // this.props.filterContractListPaneData(new ContractListPaneFilter());
    history.push(`/CU/${getContractingUnit()}/project/${getProject()}/contract/new`);
  };

  reloadListPaneItem = () => {
    setTimeout(() => {
      this.props.filterContractListPaneData(this.state.filter);
    }, 100);
  };

  renderShortCutPane = () => {
    return (
      <ShortCutPane
        projectId={this.state.projectId}
        shortCutPaneFilters={this.props.shortcutPaneData}
        filter={this.state.filter}
        handelShortCutPaneFilter={(selectedItem: ContractShortCutPaneItem) => this.handelShortCutPaneFilter(selectedItem)}
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
        isExpand={false}
      />
    );
  };

  private getContractDocumentPaneView = () => {
    const ContractDocumentPane = require('./documentPane/container').default;

    let bookmarkList: BookMarkItem[] = [
      { id: 1, link: 'lot', label: this.props.t('lot') },
      { id: 2, link: 'lot-budget', label: this.props.t('lotBudget') },
      { id: 3, link: 'contractor-list', label: this.props.t('contractorList') },
      { id: 4, link: 'documentation', label: this.props.t('documentation') },
      { id: 5, link: 'technical-documentation', label: this.props.t('technicalDocumentation') },
      { id: 6, link: 'publish-tender', label: this.props.t('publishTender') },
      { id: 7, link: 'tender-awarding', label: this.props.t('tenderAwarding') },
      { id: 8, link: 'timetable-lot', label: this.props.t('timetableLot') },
      { id: 9, link: 'history', label: this.props.t('history') },
    ];

    return (
      <div>
        <DocumentPaneSection
          collapseBookmarkPane={this.state.collapseBookmarkPane}
          showProgress={this.props.showProgressBar}
          handleScroll={this.props.handleScroll}
          isEdit={this.props.isEdit}
          formData={this.props.formData ? this.props.formData : {}}
          bookmarkList={bookmarkList}
          currentActiveSection={this.props.currentActiveSection}
          renderCommandBar={() => <CommandBarRight/>}
          isRefresh={this.props.isEdit}
        >
          <ContractDocumentPane />
        </DocumentPaneSection>
      </div>
    );
  };

  private getContractorDocumentPaneView = () => {
    const ContractorDocumentPane = require('./constructorDocumentPane/container').default;

    let bookmarkList: BookMarkItem[] = [
      { id: 1, link: 'constructor-lot-info', label: this.props.t('constructorLotInfo') },
      { id: 2, link: 'all-lots-contractor', label: this.props.t('allLotsContractor') },
      { id: 3, link: 'time-table-contractor', label: this.props.t('timeTableContractor') },
      { id: 4, link: 'accreditations-and-suppliers-list', label: this.props.t('accreditationsAndSuppliersList') },
      { id: 5, link: 'history', label: this.props.t('history') },
    ];

    return (
      <DocumentPaneSection
        collapseBookmarkPane={this.state.collapseBookmarkPane}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.props.isEdit}
        formData={this.props.constructorFormData ? this.props.constructorFormData : {}}
        bookmarkList={bookmarkList}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight/>}
        isRefresh={this.props.isEdit}
        renderAlert={() => <CustomAlert
          width={'80%'}
          showMsg={this.state.showMsg}
          msg={this.state.alertMsg}
          msgType={this.state.alertMsgType}
          handleCustomAlert={(showMsg: boolean) => this.setState({ showMsg })}
        />}
      >
        <ContractorDocumentPane />
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          (this.state.selectedShortCutItem && this.state.selectedShortCutItem.name)
            ? this.state.selectedShortCutItem.name!!
            : i18n.t('all')
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={false}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          reloadListPaneItem={() => this.reloadListPaneItem()}
          filter={this.state.filter}
          listPaneItems={this.props.contractList}
          isDataLoaded={this.props.isContractListLoaded}
          isChange={this.props.isChange}
          formData={this.props.selectedLotType === CONTRACT ? this.state.formData : this.state.constructorFormData}
          handelFilter={(filter: ContractListPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(
            selectedListItemIds: [] | string[],
          ) => {
            //this.handleSelectedListPaneItem(selectedListItemIds);
          }}
          reSizer={this.state.reSizer}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: ContractListPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      this.setState({
        filter: filter,
      }, this.reloadListPaneItem);
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: ContractShortCutPaneItem) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  // getDocumentPaneView = (type: string) => {
  //   switch (type) {
  //     case 'Contract':
  //       return this.getContractDocumentPaneView();
  //     case 'Contractor':
  //       return this.getContractorDocumentPaneView();
  //     default:
  //       return this.getContractDocumentPaneView();
  //   }
  // }

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                // isDrag:true,
                // collapseBookmarkPane:true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: 'all 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>
                      {this.props.selectedLotType === CONTRACT ? this.getContractDocumentPaneView() : this.getContractorDocumentPaneView()}
                    </div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('contract')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.props.selectedLotType === CONTRACT ? this.getContractDocumentPaneView() : this.getContractorDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={true}
          title={t('areyousure')}
          subText={t('youwonTbeabletorevertthis')}
          onClickConfirmDialog={() => {
          }}
          onClickCancelDialog={() => {
          }}
          cancelButtonText={t('noIwonT')}
          confirmButtonText={t('yesDeleteit')}
        />
      </div>
    );
  }

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    history.push(`/CU/${getContractingUnit()}/project/${getProject()}/contract`);
  };

  private hideDocumentPane = () => {
    if (getContractingUnit()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/contract`);
    } else {
      //history.push(`/template`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.contract?.contractShortCutPaneData,
    isContractListLoaded: state.contract.isContractListLoaded,
    contractList: state.contract.contractList,
    contractDropDowns: state.contract.contractDropDowns,
    reloadListPane: state.contract.reloadListPane,
    formData: state.contract.formData,
    isEdit: state.contract.isEdit,
    showProgressBar: state.contract.showProgressBar,
    selectedLotType: state.contract.selectedLotType,
    constructorFormData: state.contract.constructorFormData,
    isInviteSend: state.contract.isInviteSend,
  };
};

const mapDispatchToProps = {
  readContractShortCutPaneData,
  filterContractListPaneData,
  readContractDropDownData,
  readByContractId,
  readByConstructorId,
  clearFormData,
  saveContractStateAttr,
  getContractingUnits,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI((ContractMainLayout))),
  ));
